import React from 'react';
import { insert, pipe } from 'ramda';
import { useSelector } from 'react-redux';

import { PosPlugin } from 'plugins/plugin';
import Icon from 'components/Icon';
import { getClientCode } from 'reducers/Login';

const serviceApp: PosPlugin = {
  id: 'service-app-plugin',
  name: 'Service App',
  keywords: ['service app', 'service', 'app'],
  info: 'Will enable service app link in header',
  ComponentHeader: ({ children }) => {
    const clientCode = useSelector(getClientCode);
    const serviceAppUrl = `https://service-app.erply.com/?auth=cookie&clientCode=${clientCode}`;
    function openServiceApp() {
      window.open(serviceAppUrl, '_blank');
    }
    return (
      <>
        <Icon action={openServiceApp} name="vehicle" />
        {children}
      </>
    );
  },
};

export default serviceApp;
